import { useMemo, useContext } from 'react';
import ReactEcharts from 'echarts-for-react';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { sinTimeDimensionSinIndexMulValue } from '@/utils/reportResponseUtil';

const PieDistribution = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const { loading6, loading7, data = [], title } = props;

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const option = useMemo(() => {
    if (!data || data.length === 0) {
      return null;
    }
    const seriesData = sinTimeDimensionSinIndexMulValue(data || []).map((e) => {
      return {
        value: e.VALUE,
        name: e.LABEL,
      };
    });

    return {
      legend: {
        left: 'right',
        itemHeight: 5,
        itemWidth: 15,
        zlevel: 1,
        top: -5,
      },
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      // tooltip: {
      //   trigger: 'item',
      //   textStyle: {
      //     fontSize: chartsFontSize.s03,
      //   },
      // },
      color: charts.barColorList,
      series: [
        {
          name: title,
          type: 'pie',
          radius: ['50%', '80%'],
          data: seriesData,
          avoidLabelOverlap: false,
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 2,
            label: true,
          },
          label: {
            show: true,
            formatter: '{b}\n{c}({d}%)',
            alignTo: 'labelLine',
            position: 'outer',
          },
          labelLine: {
            show: true,
          },
          top: 10,
          bottom: 10,
        },
      ],
    };
  }, [charts.barColorList, chartsFontSize.s03, data, fontFamily, title]);

  return (
    <>
      <Head boxId={title}></Head>
      <Body bizData={data} loading={loading7 || loading6}>
        {option && (
          <ReactEcharts
            style={{ width: '100%', height: '100%' }}
            option={option}
            notMerge={true}
            lazyUpdate={true}
          />
        )}
      </Body>
    </>
  );
};
export default PieDistribution;
